import React, { useState } from "react";
import { useDispatch } from "react-redux";

import Loading from "../../../common/Loading";

import { Button, CheckboxField } from "../../../helpers";

import { updateSellerPO } from "../../../services/api/sellerPO";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";


const DownloadSellerPODialog = (props) => {
    const { sellerPO, setSellerPO, downloadSellerPO, setIsDownloadDialogVisible } = props

    const [isLoading, setIsLoading] = useState(false)
    const [sendMailSeparately, setSendMailSeparately] = useState(false)

    const dispatch = useDispatch()

    const handleDownloadSellerPO = async () => {
        if (window.confirm("Do you want to download the seller po?")){
            let data = {
                emailSent: true
            }
            setIsLoading(true)
            const updateSellerPORes = await updateSellerPO(sellerPO.sellerPOId, data)
            setIsLoading(false)
    
            if (updateSellerPORes.failure){
                return dispatch(raiseToast({severity:'error', summary: "Download Seller PO", detail: updateSellerPORes.data.error, life: 3000}))
            }

            downloadSellerPO()
            setSellerPO(prevState => ({...prevState, emailSent: true}))
            setIsDownloadDialogVisible(false)
        }
    }

    return (
        <>
            <Loading visible={isLoading}/>
            <div className="">
                <div className="flex flex-row mb-2">
                    <CheckboxField className="col" label="Seller e-mail sent separately" onChange={() => setSendMailSeparately(!sendMailSeparately)} checked={sendMailSeparately} />
                </div>
                <div className="mt-5 flex flex-row justify-content-center">
                    <Button label="Download" outlined disabled={!sendMailSeparately} onClick={() => handleDownloadSellerPO()} />
                </div>
            </div>
        </>
    )
}

export default DownloadSellerPODialog